import { defineStore } from 'pinia';

const useSubscribeModalQueryVarsStore = defineStore('subscribeModalQueryVars', () => {
    const subscribeModalQueryVars = ref('');
    return { subscribeModalQueryVars };
});

export { useSubscribeModalQueryVarsStore };
